/**
 * Keeps the whole branch of a matched filter item visible: a match nested a few
 * levels deep is meaningless without the groups it hangs from.
 */
export default function showAncestors ({ dispatch, categoryIndex, items, item }) {
  let current = item
  let guard = 0

  while (current.parent && guard < 10) {
    const parent = items.find(candidate => candidate.guid === current.parent)
    if (!parent) break

    dispatch('updateItemShow', { categoryIndex, guid: parent.guid, status: true })
    current = parent
    guard += 1
  }
}
